import React, { useContext, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useBanner from "../../../../services/Inventory/useBanner";
import { GlobalContext } from "../../../../Context/GlobalContext";
import HtmlEditor from "./HtmlEditorComponents/HtmlEditor";
import CreateNewBanner from "./CreateNewBanner";
import BannerLibrary from "./BannerLibrary";
import NoIndex from "../../../../components/NoIndex";
import { ToastContainer } from "react-toastify";

const ROUTES = {
  BANNER_LIBRARY: "/inventory/banner",
  CREATE_BANNER: "/inventory/banner/create-new-banner",
  HTML_EDITOR: "/inventory/banner/html-editor",
};

function Banner() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setGeneratedHTML } = useContext(GlobalContext);

  const { fetchBanner, updateBannerStatus } = useBanner();

  const [fetchedBanner, setFetchedBanner] = useState([]);
  const [previewHTML, setPreviewHTML] = useState("");
  const [showModal, setShowModal] = useState(false);

  const ITEMS_PER_PAGE = 8;
  const [currentPage, setCurrentPage] = useState(1);

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentItems = fetchedBanner.slice(startIndex, startIndex + ITEMS_PER_PAGE);
  const totalPages = Math.ceil(fetchedBanner.length / ITEMS_PER_PAGE);

  const openPreview = (html) => {
    setPreviewHTML(html);
    setShowModal(true);
  };

  const closePreview = () => {
    setShowModal(false);
    setPreviewHTML("");
  };

useEffect(() => {
  if (location.pathname.startsWith(ROUTES.BANNER_LIBRARY)) {
    fetchBanner(setFetchedBanner);
  }
}, [location.pathname]);

  //  Helper: active tab check
  const isActive = (route) => location.pathname === route;

  const tabStyle = (route) => ({
    borderBottom: isActive(route) ? "3px solid #00c47d" : "3px solid transparent",
    color: isActive(route) ? "#00c47d" : "black",
    borderRadius: "0px",
  });

  return (
    <>
    <NoIndex/>
<ToastContainer/>

    <div className="d-flex flex-column justify-content-start align-items-start mx-4 flex flex-col items-start px-6 py-6 h-screen overflow-hidden montserrat-font-1">

      <div className="w-full flex flex-col gap-0 items-start montserrat-font-1">

        {/* Header */}
        <div className="flex justify-between mb-1 w-full">
          <div className="flex flex-col">
            <h2 className="CreateCampaign text-xl font-semibold montserrat-font-1">
              Banner Management
            </h2>
            <p className="text-gray-500 montserrat-font-2">
              Create reusable banner templates that save time and ensure consistency
            </p>
          </div>
        </div>

        {/*  Tabs — sirf 2 tabs show hote hain (Library + Create) */}
        <div className="flex gap-3 border-b pb-0 w-full">

          {/* Tab 1 - Banner Library */}
          <button
            className="btn border-none fw-normal px-3 py-2 montserrat-font-1"
            style={tabStyle(ROUTES.BANNER_LIBRARY)}
            onClick={() => navigate(ROUTES.BANNER_LIBRARY)}
          >
            Banner Library
          </button>

          {/* Tab 2 - Create Banner */}
          <button
            className="btn border-none fw-normal px-3 py-2 montserrat-font-1"
            style={tabStyle(ROUTES.CREATE_BANNER)}
            onClick={() => {
              setGeneratedHTML("");
              navigate(ROUTES.CREATE_BANNER);
            }}
          >
            Create Banner
          </button>
        </div>

        {/* Content — route ke hisaab se render */}
        <div className="mt-2 w-full montserrat-font-1">

          {/* HTML Editor Route */}
          {isActive(ROUTES.HTML_EDITOR) && <HtmlEditor />}

          {/*  Banner Library — default route, yahan banner cards dikhenge */}
         {isActive(ROUTES.BANNER_LIBRARY) && <BannerLibrary />}

          {/*  Create Banner Route */}
          {isActive(ROUTES.CREATE_BANNER) && (
            <div style={{ width: "55vw", height: "100%" }}>
              <CreateNewBanner />
            </div>
          )}
        </div>
      </div>

      {/* Modal Preview */}
      {showModal && (
        <div className="banner-preview-modal fixed inset-0 bg-black bg-opacity-40 flex montserrat-font-1 justify-center items-center z-50">
          <div className="banner-preview-content bg-white rounded-lg p-4 w-[80%]">
            <div className="flex justify-between items-center mb-3">
              <h5 className="font-semibold">Banner Preview</h5>
              <button className="btn btn-sm btn-light" onClick={closePreview}>
                ✕
              </button>
            </div>

            <div
              className="hide-scrollbar overflow-scroll flex"
              style={{
                backgroundColor: "#ebebeb",
                height: "70vh",
                borderRadius: "8px",
                padding: "10px",
              }}
              dangerouslySetInnerHTML={{ __html: previewHTML }}
            />
          </div>
        </div>
      )}
    </div>
    </>
  );
}

export default Banner;